import { HttpClient } from '@angular/common/http';
import { of as observableOf, combineLatest } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';
import { GenericResultModel } from '@app/models';
import { DataService, LoginService } from '@app/core';
import { ReportFilterService } from '@app/report-filters/service/report-filter.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../auth/login.service";
import * as i3 from "../../report-filters/service/report-filter.service";
const API_ENDPOINT = 'api/v1/derivative/';
import { IDerivativeSearchService, ISearchResultModel, SearchResultModel, IDerivativeSearchModel, ISimilarSearchService, ISimilarSearchModel } from 'vehicle-search';
export class DerivativeSearchService extends DataService {
    constructor(httpClient, loginService, reportFilterService) {
        super(httpClient, loginService);
        this.reportFilterService = reportFilterService;
    }
    similarSearch(searchModel) {
        let headers = this.getAuthorisationHeader();
        let query = API_ENDPOINT + `similar`;
        return this.httpClient
            .post(query, searchModel, {
            headers: headers,
        })
            .pipe(map((data) => {
            if (data && data.success) {
                return data.result;
            }
        }), catchError(this.handleErrorWithModel('DerivativeSearchService', 'similarSearch', new SearchResultModel(0, 0, 0, 0, 0, [], []))));
    }
    linkedSearch(searchModel) {
        let headers = this.getAuthorisationHeader();
        let query = API_ENDPOINT + `linked`;
        return this.httpClient
            .post(query, searchModel, {
            headers: headers,
        })
            .pipe(map((data) => {
            if (data && data.success) {
                return data.result;
            }
        }), catchError(this.handleErrorWithModel('DerivativeSearchService', 'linkedSearch', new SearchResultModel(0, 0, 0, 0, 0, [], []))));
    }
    derivativeSearch(searchModel) {
        //var singleCountryMode = true; // ToDo V set from user restrictions
        //var defaultCountryCode = 'GB';
        //searchModel.filters = new FilterRequest('countryCode', ['GB']);
        return combineLatest(observableOf(searchModel)).pipe(
        //filter((filters) => singleCountryMode ? filters[1]['countryId'] > 0: true),
        //map(([filterSettings, searchModel]) => {
        //  return searchModel;
        //}),
        switchMap((filters, ind) => {
            //return this.requestDerivativeSearch(filters[0], (singleCountryMode ? filters[1]['countryCode'] : null));
            return this.requestDerivativeSearch(filters[0]);
        }));
    }
    requestDerivativeSearch(searchModel, countryCode) {
        //console.log('derivativeSearch: ', searchModel/*, countryCode*/);
        let headers = this.getAuthorisationHeader();
        //let params = this.getParamsFromObject(filter);
        let query = API_ENDPOINT + `search`;
        //if (countryCode)
        //  query += `?cc=${countryCode}`
        return this.httpClient
            .post(query, searchModel, {
            headers: headers,
        })
            .pipe(map((data) => {
            //console.log('derivativeSearch: result ', data);
            if (data && data.success) {
                return data.result;
            }
        }), catchError(this.handleErrorWithModel('DerivativeSearchService', 'derivativeSearch', new SearchResultModel(0, 0, 0, 0, 0, [], []))));
    }
}
DerivativeSearchService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DerivativeSearchService_Factory() { return new DerivativeSearchService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.LoginService), i0.ɵɵinject(i3.ReportFilterService)); }, token: DerivativeSearchService, providedIn: "root" });
